export const DEFAULT_COLOR = '#1677ff00';
